export const FETCHING_INFO = "infomacaosaude.buscando_info";
export const FETCHING_INFO_COMPLETE = "infomacaosaude.buscou_info";
export const FETCHING_INFO_ERROR = "infomacaosaude.buscou_info_Error";
export const FILTER_MORB_SELECTED = "infomacaosaude.filtrou_morbidades";
export const FILTER_ESPECIALIDADE_SELECTED = "infomacaosaude.filtrou_especi";
export const CHANGE_PROFISSIONAL = "infomacaosaude.mudou_profissionais";
export const CHANGE_DOCTOR = "infomacaosaude.CHANGE_DOCTOR";
